var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12305 17.9079C7.43829 18.0607 7.82456 18.1599 8.33829 18.1599C10.4166 18.1599 10.4166 16.5039 12.4958 16.5039C14.575 16.5039 14.575 18.1599 16.6543 18.1599C17.167 18.1599 17.5543 18.0607 17.8783 17.9079",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4728 3H14.9252C16.9656 3.12162 18.0164 4.65503 17.8695 6.50854C17.7469 7.79481 16.5472 8.96627 14.4728 10.9579C13.8054 11.6536 13.8054 12.3464 14.4728 13.0411C16.5472 15.0328 17.7469 16.2052 17.8695 17.4915C18.0164 19.345 16.9656 20.8784 14.9252 21H10.075C8.03368 20.8784 6.98384 19.345 7.13076 17.4915C7.25336 16.2052 8.45303 15.0328 10.5274 13.0411C11.1949 12.3464 11.1939 11.6536 10.5274 10.9579C8.45303 8.96627 7.25336 7.79481 7.13076 6.50854C6.98384 4.65503 8.03368 3.12162 10.075 3H10.5274",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.ffab420341bdcaa5dd5a94bb3b1a3843.svg";
export { ForwardRef as ReactComponent };